import { Component, OnInit } from '@angular/core';
import { IndicatorsSearchToolbarModel } from '../../../../models/indicators-search-toolbar-model.model';
import { IndicatorBoxModel } from '../../../../models/indicator-box.model';
import { LoyaltyChart } from '../../../../models/loyalty-chart-config.model';
import { QFilterModel } from '../../../../models/qfilter.model';
import { IndicatorsChartService, IndicatorsService } from '../../../../services/indicators/indicators.service';
import { AnalyticsService } from '../../../../services/analytics/analytics.service';
import { CustomerCampaignService } from '../../../../services/customer/customer-campaign.service';
import { TranslateService } from '@ngx-translate/core';
import { SearchToolbarModelFactoryService } from '../../../../services/search-toolbar-model-factory/search-toolbar-model-factory.service';
import { SearchToolbarDateFunction, SearchToolbarFactoryParameters, SearchToolbarFilterGrouping, SearchToolbarFilterWindow, SearchToolbarSection } from '../../../../models/search-toolbar-factory-parameters.model';

// Pagina 10
@Component({
  selector: 'app-contactable-channel',
  templateUrl: './contactable-channel.component.html',
  styleUrls: ['./contactable-channel.component.css']
})
export class ContactableChannelComponent implements OnInit {
  show_results = false;

  public searchModel: IndicatorsSearchToolbarModel = new IndicatorsSearchToolbarModel();
  public indicators: IndicatorBoxModel[] = [];
  public translations: any;
  public storeError = false;
  public selectOneError: string;
  public contactChannelChart: LoyaltyChart;
  public customersForChannelChart: LoyaltyChart;
  public data: QFilterModel;

  constructor(
    private indicatorService: IndicatorsService,
    private chartsService: IndicatorsChartService,
    private svcAnalytics: AnalyticsService,
    private srvCustomerCampaign: CustomerCampaignService,
    private translate: TranslateService,
    private searchModelFactory: SearchToolbarModelFactoryService,
  ) { }

  ngOnInit() {

    this.initChart();

    this.translate.get([
      'contactable.contactChannel',
      'contactable.customersForChannel',
      'contactable.attivi',
      'contactable.nonattivi'
    ]).subscribe((t) => {
      this.translations = {
        contactChannel: t['contactable.contactChannel'],
        customersForChannel: t['contactable.customersForChannel'],
        attivi: t['contactable.attivi'],
        nonattivi: t['contactable.nonattivi']
      };
    });

    this.translate.get('store.selectOneErrorMsg').subscribe(msg => { this.selectOneError = msg; });

  }

  initChart() {
    this.contactChannelChart = new LoyaltyChart('bar');
    this.contactChannelChart.options.legend = {layout: 'horizontal', align: 'center', verticalAlign: 'bottom', reversed: true};
    this.contactChannelChart.options.plotOptions = {series: {stacking: 'normal'}};

    this.customersForChannelChart = new LoyaltyChart('line');
    this.customersForChannelChart.options.legend = {layout: 'horizontal', align: 'center', verticalAlign: 'bottom'};
    this.customersForChannelChart.options.chart.zoomType = 'xy';
  }


  setChartInstance(chart: LoyaltyChart, chartInstance) {
    chart.instance = chartInstance;
  }

  searchValue(data: QFilterModel) {
    this.data = data;

    this.indicators = [];
    this.indicatorService.indicatorCalculation('Q037', this.data).subscribe(res => {

      this.indicators.push(new IndicatorBoxModel([res.find(r => r.name === 'iscritti_loyalty')], {dynamic: true, decimal_value: 2, decimal_prec_value: 2}));
      this.indicators.push(new IndicatorBoxModel([res.find(r => r.name === 'raggiungibilita_clienti')], {dynamic: true, decimal_value: 2, decimal_prec_value: 2, unit_period_prec: '%'}));
      this.indicators.push(new IndicatorBoxModel([res.find(r => r.name === 'clienti_profilabili')], {dynamic: true, decimal_value: 2, decimal_prec_value: 2, unit_period_prec: '%'}));
      this.indicators.push(new IndicatorBoxModel([res.find(r => r.name === 'clienti_target')], {dynamic: true, decimal_value: 2, decimal_prec_value: 2, unit_period_prec: '%'}));

    });

    this.contactChannelInit (data);
    this.customersForChannelInit (data);
    this.show_results = true;
  }

  public toogleErrorStoreDialog() {
    this.storeError = !this.storeError;
  }

  public contactChannelInit (data: QFilterModel) {
    this.indicatorService.getChart('customers.Q129', data, false).subscribe( res => {

      let series: Array<any> = [
        {name: this.translations.nonattivi, data: res.series[2].serie, color: LoyaltyChart.colors[22]},
        {name: this.translations.attivi, data: res.series[1].serie, color: LoyaltyChart.colors[1]}
      ];

      if (this.contactChannelChart.instance) {
        while (this.contactChannelChart.instance.series.length > 0) {
          this.contactChannelChart.instance.series[0].remove(true);
        }
      }

      this.contactChannelChart.options.xAxis.categories = res.series[0].serie;
      this.contactChannelChart.options.series = series;

      for (let i = 0; i < series.length; i++) {
        this.contactChannelChart.instance.addSeries(series[i]);
      }

      this.contactChannelChart.instance.update(this.contactChannelChart.options);
      this.contactChannelChart.instance.redraw();
    });
  }

  public customersForChannelInit (data: QFilterModel) {
    this.chartsService.loadChart(this.customersForChannelChart, 'customers.Q130', data, this.indicatorService, this.translate);
  }

  resetData() {
    this.show_results = false;
  }

}



// WEBPACK FOOTER //
// ./src/app/views/customerDB/customers-contactable/contactable-channel/contactable-channel.component.ts